<template>
    <a class="o-highlights__back" v-bind:class="{'o-highlights__back--active': !previous_route_name, 'o-highlights__back--desktop': location == 'desktop','o-highlights__back--mobile': location == 'mobile' }" href="/">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 87 50" style="enable-background:new 0 0 87 50;" xml:space="preserve">
            <path d="M82.3,21H14.5L27.7,7.8c1.6-1.6,1.6-4.1,0-5.7s-4.1-1.6-5.7,0l-20,20c-0.4,0.4-0.7,0.8-0.9,1.3c-0.4,1-0.4,2.1,0,3.1
            c0.2,0.5,0.5,0.9,0.9,1.3l20,20c0.8,0.8,1.8,1.2,2.8,1.2c1,0,2-0.4,2.8-1.2c1.6-1.6,1.6-4.1,0-5.7L14.5,29h67.7c2.2,0,4-1.8,4-4
            S84.5,21,82.3,21z"/>
        </svg>
        Back
    </a>
</template>

<script>
export default {
    props: ['location'],
    data: function() {
        return {
            at_rest: false,
        }
    },
    mounted() {

        setTimeout(() => {
            this.at_rest = true;
        }, 2000);
    },
}
</script>
